import { BlockUI, NgBlockUI }              from 'ng-block-ui';
import { Component }                       from '@angular/core';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { NgbActiveModal }                  from '@ng-bootstrap/ng-bootstrap';
import { TranslateService }                from '@ngx-translate/core';

import { ApiService }      from '../api/api.service';
import { MessagesService } from '../messages/messages.service';
import { SessionService }  from '../sessions/session.service';
import { STATUSCODES }     from '../api/api.status-codes.constant';

@Component({
  selector   : 'wor-sync-quickbooks',
  template: require('./quickbooks.sync.component.html')
})
export class SyncQuickbooksComponent {
  private _STATUSCODES = STATUSCODES;

  public email : string = this.sessionService.company().admin_email;

  @BlockUI('syncQuickbooksBlock') block : NgBlockUI;

  constructor (
    private activeModal     : NgbActiveModal,
    private apiService      : ApiService,
    private messagesService : MessagesService,
    private sessionService  : SessionService,
    private translateService: TranslateService
  ) {}

  sync () : void {
    this.block.start();

    this.apiService.post('quickbooks_online/sync', { email: this.email }, undefined, undefined, { verbose: true }).
    then(( response : HttpResponse<any> ) => {
      this.activeModal.close(response.body);
    })
    .catch(( error : HttpErrorResponse ) => {
      if (error.status === this._STATUSCODES.timeout) {
        this.messagesService.show(this.translateService.instant('JS_SPACE.INTEGRATIONS.SYNC_STARTED_SUCCESSFULLY', {
          name: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.QUICKBOOKS.QUICKBOOKS_ONLINE')
        }), 'success');

        this.activeModal.dismiss();
      }
      else {
        this.messagesService.error(error.error);
      }
    })
    .finally(() => {
      this.block.stop();
    });
  }
}
